'use strict';

var tldPattern = /^(?:\.[\S]+ \()?(\.[\S]+?)\)?\s+/,
    tierPattern = /\[?tier\s+(\d+)\]?/i,
    domainNamePattern = /domain name\s+/i,
    numberOfTermsPattern = /(?:\s*-\s*(\d+)\s*years?(?:\s*\(recurring\))?)$/i,
    registrationRenewalPattern = /(?:registration\s*-\s*)?(renewal)/i,
    preRegistrationPattern = /(?:\(pre-registration\)\s*)(registration)/i,
    typePattern = /(renewal|registration|transfer)/i,
    multipleSpacePattern = /\s{2,}/;

module.exports = {
  parseName: function parseName(name) {
    if (name == null || typeof name !== 'string') {
      throw new Error('name is required string');
    }

    var token = {
      fullName: name,
      displayName: null,
      groupName: null,
      tld: null,
      tier: null,
      numberOfTerms: null,
      type: null
    },
        tldMatch = tldPattern.exec(token.fullName),
        tierMatch = tierPattern.exec(token.fullName),
        numberOfTermsMatch = numberOfTermsPattern.exec(token.fullName);

    if (tldMatch) {
      token.tld = tldMatch[1];
    }

    if (tierMatch) {
      token.tier = parseInt(tierMatch[1]);
    }

    if (numberOfTermsMatch) {
      token.numberOfTerms = parseInt(numberOfTermsMatch[1]);
    }

    token.displayName = token.fullName.replace(tldPattern, '').replace(tierPattern, 'Tier $1').replace(domainNamePattern, '').replace(preRegistrationPattern, '$1').replace(registrationRenewalPattern, '$1').replace(numberOfTermsPattern, '').replace(multipleSpacePattern, ' ').trim();

    var typeMatch = typePattern.exec(token.displayName);

    if (typeMatch) {
      token.type = typeMatch[1].toLowerCase();
    }

    token.groupName = token.displayName.replace(typePattern, '').trim();

    if (!token.groupName) {
      token.groupName = 'Base';
    }

    return token;
  }
};